export function ScrollableAnchor({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) {
  return (
    <div id={id} className="scrollable-anchor" data-scrollable-anchor={'true'}>
      {children}
    </div>
  );
}
